var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulScheduledPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6173FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.023 17.769c-.625-.674-.756-1.062-.756-1.269 0-.207.131-.595.756-1.269.557-.601 1.34-1.254 2.168-1.946 2.19-1.828 4.673-3.9 4.804-6.478.066-1.313-.497-2.594-1.675-3.807H9.683c-1.18 1.215-1.744 2.497-1.678 3.811.129 2.576 2.603 4.648 4.786 6.475.826.691 1.605 1.344 2.16 1.945.623.674.754 1.062.754 1.269 0 .207-.131.595-.754 1.269-.555.601-1.334 1.254-2.16 1.945-2.183 1.827-4.657 3.899-4.786 6.475-.066 1.314.499 2.596 1.678 3.811H23.32c1.178-1.213 1.741-2.494 1.675-3.807-.131-2.578-2.614-4.65-4.804-6.478-.828-.692-1.61-1.345-2.168-1.946z",
    opacity: 0.165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.192 28.264h-3.545c.736-.866 1.077-1.698 1.036-2.533-.049-1.013-.654-1.97-1.277-2.731H10.614c-.62.764-1.219 1.715-1.268 2.726-.04.837.301 1.67 1.039 2.538H6.808c-.446 0-.808.389-.808.868 0 .48.362.868.808.868h19.384c.446 0 .808-.389.808-.868s-.362-.868-.808-.868zM26.192 4H6.808C6.362 4 6 3.552 6 3s.362-1 .808-1h19.384c.446 0 .808.448.808 1s-.362 1-.808 1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulScheduledPost);
export default __webpack_public_path__ + "static/media/icons-colorful-scheduled-post.b8a22f02.svg";
export { ForwardRef as ReactComponent };